import { HandleVibrate } from "./HandleApiData";

export default function CButton({
    text,
    onClick,
    icon,
    className,
    action = 'normal',
    disabled
}) {
    const onMouseUp = (e) => {
        HandleVibrate();
    }
    return (
        <button className={`cButton ${className ? className : ''} ${action ? action : ''}`} onMouseUp={onMouseUp} onClick={onClick} disabled={disabled}>
            <div className="inner">
                <div className="icon">
                    {icon}
                </div>
                <span>
                    {text}
                </span>
            </div>
        </button>
    );
}